import { jwtDecode } from "jwt-decode";

import {
    getInvitedSignatorySessionData,
    INVITEDSIGNATORYSTATE,
    setInvitedSignatorySessionData,
} from "../../utils/localStorage";
import * as types from "../actions/types/invitedSignatory.types";

const initialState = {
    kudaAccountOption: "",
    fetchInvitedSignatoryState: "idle",
    fetchInvitedSignatoryErrMsg: "",
    inviteeData: {
        inviteeEmail: "",
        smeProfileID: "",
        inviteeLastName: "",
        inviteeFirstName: "",
        inviteeMiddleName: "",
        inviter: "",
        inviterSignatoryID: "",
        accessLevel: "",
        requestID: "",
        id: "",
        isExists: false,
        userEmail: "",
        email: "",
        userRetailAccountPassword: "",
        userID: "",
        dateOfBirth: "",
        phoneNumber: "",
        country: "",
        stateObj: null,
        lga: null,
        address: "",
        updateFlag: "none",
        docs: {
            utilityBillFileUrl: "",
            residentPermitFileUrl: "",
        },
        nextOfKin: {
            firstName: "",
            lastName: "",
            houseAddress: "",
            email: "",
            relationship: "",
            phoneNumber: "",
        },
        meansOfIdentification: "",
        idNumber: "",
        bvn: "",
        gender: "",
        nerveCustomerId: "",
        profileImageFileUrl: "",
    },
    validateUserErrMsg: "",
    validateInviteeState: "idle",
    createPasswordState: "idle",
    createSignatoryState: "idle",
    inviteStatusCode: "",
};

export const inviteSignatoryReducer = (state = initialState, action) => {
    switch (action.type) {
        case types.FETCH_INVITEE_STARTED:
            return {
                ...state,
                fetchInvitedSignatoryState: "loading",
            };
        case types.FETCH_INVITEE_SUCCEEDED:
            const data = jwtDecode(action.payload.accessToken);
            const sessionData = {
                ...getInvitedSignatorySessionData(INVITEDSIGNATORYSTATE),
                inviteeEmail: data.email,
                smeProfileID: action.payload.smeProfileID,
                inviteeLastName: action.payload.inviteeLastName,
                inviteeFirstName: action.payload.inviteeFirstName,
                designation: data.role || action.payload.designation,
                inviter: action.payload.inviter,
                inviterSignatoryID: action.payload.inviterSignatoryID,
                accessLevel:
                    action.payload.accessLevel === "Signatory"
                        ? 2
                        : action.payload.accessLevel === "Admin"
                        ? 1
                        : action.payload.accessLevel === "Staff"
                        ? 3
                        : null,
                requestID: action.payload.requestID,
                id: action.payload.id,
                userEmail: action.payload.inviteeEmail,
            };
            setInvitedSignatorySessionData(INVITEDSIGNATORYSTATE, sessionData);

            return {
                ...state,
                fetchInvitedSignatoryState: "success",
                inviteStatusCode: action.statusCode,
                inviteeData: {
                    ...state.inviteeData,
                    ...sessionData,
                },
            };
        case types.FETCH_INVITEE_FAILED:
            return {
                ...state,
                fetchInvitedSignatoryState: "failed",
                fetchInvitedSignatoryErrMsg: action.payload,
            };
        case types.SET_CUSTOMER_OPTIONS:
            return {
                ...state,
                kudaAccountOption: action.payload,
            };
        case types.VALIDATE_INVITEE_STARTED:
            return {
                ...state,
                validateInviteeState: "loading",
            };
        case types.VALIDATE_INVITEE_SUCCEEDED:
            return {
                ...state,
                validateInviteeState: "success",
                inviteeData: {
                    ...state.inviteeData,
                    inviteeFirstName: action.payload?.data?.firstName,
                    inviteeMiddleName: action.payload?.data?.middleName,
                    inviteeLastName: action.payload?.data?.lastName,
                    email: action.payload?.data?.email,
                    userID: action.payload?.data?.userID,
                    dateOfBirth: action.payload?.data?.dateOfBirth,
                    phoneNumber: action.payload?.data?.phoneNumber,
                    address: action.payload?.data?.address,
                    meansOfIdentification: action.payload?.data?.meansOfIdentification,
                    idNumber: action.payload?.data?.idNumber,
                    bvn: action.payload?.data?.bvn,
                    gender: action.payload?.data?.gender,
                    isExists: action.payload?.data?.userExists
                        ? action.payload?.data?.userExists
                        : false,
                    profileImageFileUrl: action.payload?.data?.profileImageFileUrl,
                    nerveCustomerId: action.payload?.data?.nerveCustomerId,
                    userEmail: action.payload?.userEmail,
                },
            };
        case types.VALIDATE_INVITEE_FAILED:
            return {
                ...state,
                validateInviteeState: "failed",
                validateUserErrMsg: action.payload,
            };
        case types.CREATE_NEW_PASSWORD:
            setInvitedSignatorySessionData(INVITEDSIGNATORYSTATE, {
                ...getInvitedSignatorySessionData(INVITEDSIGNATORYSTATE),
                password: action.payload.password,
            });
            return {
                ...state,
                createPasswordState: "success",
                inviteeData: {
                    ...state.inviteeData,
                    password: action.payload.password,
                },
            };
        case types.SET_USER_INFO:
            return {
                ...state,
                inviteeData: {
                    ...state.inviteeData,
                    ...action.payload,
                },
            };
        case types.RESET_LGA:
            return {
                ...state,
                inviteeData: {
                    ...state.inviteeData,
                    lga: null,
                },
            };
        case types.SET_DATE_OF_BIRTH:
            setInvitedSignatorySessionData(INVITEDSIGNATORYSTATE, {
                ...getInvitedSignatorySessionData(INVITEDSIGNATORYSTATE),
                dateOfBirth: action.payload,
            });
            return {
                ...state,
                inviteeData: {
                    ...state.inviteeData,
                    dateOfBirth: action.payload,
                },
            };
        case types.CREATE_SIGNATORY_STARTED:
            return {
                ...state,
                createSignatoryState: "loading",
            };
        case types.CREATE_SIGNATORY_SUCEEDED:
            return {
                ...state,
                createSignatoryState: "success",
            };
        case types.CREATE_SIGNATORY_FAILED:
            return {
                ...state,
                createSignatoryState: "failed",
            };
        case types.SET_SIGNATORY_INFO:
            setInvitedSignatorySessionData(INVITEDSIGNATORYSTATE, {
                ...getInvitedSignatorySessionData(INVITEDSIGNATORYSTATE),
                [action.payload.name]: !action.payload.name ? null : action.payload.value,
            });
            return {
                ...state,
                inviteeData: {
                    ...state.inviteeData,
                    updateFlag: action.payload.name,
                    [action.payload.name]: !action.payload.name ? null : action.payload.value,
                },
            };
        case types.SET_NEXT_OF_KIN_INFO:
            setInvitedSignatorySessionData(INVITEDSIGNATORYSTATE, {
                ...getInvitedSignatorySessionData(INVITEDSIGNATORYSTATE),
                nextOfKin: {
                    ...getInvitedSignatorySessionData(INVITEDSIGNATORYSTATE).nextOfKin,
                    ...action.payload,
                },
            });
            return {
                ...state,
                inviteeData: {
                    ...state.inviteeData,
                    nextOfKin: {
                        ...state.inviteeData.nextOfKin,
                        ...action.payload,
                    },
                    updateFlag:
                        action.payload?.updateFlag === "fullObj" ? "nextOfKinObj" : "nextOfKin",
                },
            };
        case types.SET_NOK_RELATIONSHIP:
            setInvitedSignatorySessionData(INVITEDSIGNATORYSTATE, {
                ...getInvitedSignatorySessionData(INVITEDSIGNATORYSTATE),
                nextOfKin: {
                    ...getInvitedSignatorySessionData(INVITEDSIGNATORYSTATE)?.nextOfKin,
                    relationship: action.payload,
                },
            });
            return {
                ...state,
                inviteeData: {
                    ...state.inviteeData,
                    nextOfKin: {
                        ...state.inviteeData.nextOfKin,
                        relationship: action.payload,
                    },
                    updateFlag: "nextOfKin",
                },
            };
        case types.UPLOAD_BILL_STARTED:
            return {
                ...state,
                uploadFileState: "loading",
            };
        case types.UPLOAD_BILL_SUCCEEEDED:
            return {
                ...state,
                uploadFileState: "success",
                inviteeData: {
                    ...state.inviteeData,
                    docs: {
                        ...state.inviteeData.docs,
                        [action.payload.name]: !action.payload.name ? null : action.payload.url,
                    },
                    updateFlag:
                        action.payload.name === "utilityBillFileUrl" ? "utility" : "resident",
                },
            };
        case types.UPLOAD_BILL_FAILED:
            return {
                ...state,
                uploadFileState: "failed",
            };
        case types.SET_CONFIRM_INFO:
            setInvitedSignatorySessionData(INVITEDSIGNATORYSTATE, {
                ...getInvitedSignatorySessionData(INVITEDSIGNATORYSTATE),
                street: action.payload.address,
                landmark: action.payload.landmark,
                phoneNumber: action.payload.phoneNumber,
                address: action.payload.address,
                inviteeMiddleName: action.payload.middleName,
                firstName: action.payload.firstName,
                lastName: action.payload.lastName,
            });
            return {
                ...state,
                inviteeData: {
                    ...state.inviteeData,
                    street: action.payload.address,
                    landmark: action.payload.landmark,
                    phoneNumber: action.payload.phoneNumber,
                    address: action.payload.address,
                    inviteeMiddleName: action.payload.middleName,
                    firstName: action.payload.firstName,
                    lastName: action.payload.lastName,
                },
            };

        default:
            return state;
    }
};
